import 'angular';

import { downgradeComponent, downgradeInjectable } from '@angular/upgrade/static';

import { GoogleSsoSettingsComponent } from './google-sso.settings.component';
import { GoogleSsoService }           from './google-sso.service';

angular.module('app-lite.google-sso', [])
  .directive('worGoogleSsoSettings', downgradeComponent({ component: GoogleSsoSettingsComponent }) as ng.IDirectiveFactory)
  .service('googleSsoApi', downgradeInjectable(GoogleSsoService));
